import { useSuperAdminQueryHandler } from './use-query-handler'
import { SubmitHandler, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import * as z from 'zod'
import { OptionSelect } from '@/core/utils/types'
import { t } from '@lingui/core/macro'

interface SuperAdminValues {
  produto: OptionSelect
  baseUriHomolog: string
}

export const useSuperAdminForm = () => {
  const { produtos, handleEditarProduto } = useSuperAdminQueryHandler()

  const form = useForm<SuperAdminValues>({
    defaultValues: {
      produto: undefined,
      baseUriHomolog: ''
    },
    resolver: zodResolver(
      z.object({
        produto: z.object(
          { value: z.string(), label: z.string() },
          { error: t`Produto é obrigatório` }
        ),
        baseUriHomolog: z.string({ error: t`URI é obrigatória` })
      })
    ),
    mode: 'all'
  })

  const onSubmit: SubmitHandler<SuperAdminValues> = async values => {
    try {
      if (!values.produto) return
      await handleEditarProduto(values.produto.value, values.baseUriHomolog)
    } catch (e) {
      console.error('Erro ao editar produto:', e)
    }
  }

  const handleProdutoChange = (id: string) => {
    const produto = produtos.find(p => p?.id === id)
    if (!produto) return

    form.setValue('produto', {
      value: produto.id,
      label: produto.nome
    })
    form.setValue('baseUriHomolog', produto.baseUriHomolog)
  }

  return { form, onSubmit, handleProdutoChange, produtos }
}
